import type { CertificatesListItem } from '@openeducation/oe-it-shared-types';
import React, { useCallback } from 'react';
import { View } from 'react-native';

import { Loading } from '../../atoms/loading/loading';
import { CarouselBase } from '../../molecules/carousel-base/carousel-base';
import {
  CertificateCard,
  CertificateCardLabels,
} from '../../molecules/certificate-card/certificate-card';
import { flex, width, height, mr } from '../../style-utils';

export interface CertificatesCarouselProps {
  data: CertificatesListItem[];
  isLoading?: boolean;
  handleDownloadCertificate: (
    levelNum: CertificatesListItem['levelNum']
  ) => void;
  labels: CertificateCardLabels;
}

const ITEM_SPACING = 25;
const CERTIFICATE_CARD_WIDTH = 256;

export const CertificatesCarousel = ({
  data,
  isLoading,
  handleDownloadCertificate,
  labels,
}: CertificatesCarouselProps) => {
  const renderItem = useCallback(
    ({ item }: { item: CertificatesListItem }) => {
      const { levelNum, date, completed } = item;
      return (
        <CertificateCard
          blocked={!completed}
          level={levelNum}
          date={date}
          downloadAction={() => handleDownloadCertificate(levelNum)}
          style={[mr(ITEM_SPACING)]}
          blockedTextSize={10}
          labels={labels}
        />
      );
    },
    [handleDownloadCertificate, labels]
  );

  if (isLoading) {
    return (
      <View
        style={[
          flex('justify-content-center', 'align-items-center'),
          width('100%'),
          height(180),
        ]}
      >
        <Loading />
      </View>
    );
  }

  return (
    <CarouselBase<CertificatesListItem>
      data={data}
      renderItem={renderItem}
      itemWidth={CERTIFICATE_CARD_WIDTH + ITEM_SPACING}
    />
  );
};

export default CertificatesCarousel;
